module.exports = __webpack_public_path__ + "static/media/NRE_horz_spot.b3d56fa7.jpg";